import { Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
/** Thickness of the connecting band. */
const BAND_THICKNESS = 6;
/**
 * A plastic joint clip, also known as Keck clip.
 * See http://www.sciencemadness.org/smwiki/index.php/Keck_clip
 */
export class PlasticJointClip {
    render(appearance) {
        // Diameter of top ring.
        const topDiameter = appearance.diameter;
        // Diameter of bottom ring.
        const bottomDiameter = appearance.diameter + 5;
        // Distance between the rings.
        const distanceApart = 15;
        // Thickness of each ring.
        const ringThickness = 8;
        const color = baseColor(appearance.color);
        // Create the rings.
        const topRing = Shape.Rectangle(R(0, 0, topDiameter, ringThickness, Pivot.CENTER), 2.0);
        const bottomRing = Shape.Rectangle(R(0, distanceApart, bottomDiameter, ringThickness, Pivot.CENTER), 2.0);
        setRingGradient(topRing, color);
        setRingGradient(bottomRing, color);
        // Create the connecting bands.
        const bandLeft = new Path(Segments([[-topDiameter / 2, 0], , [-10, 0]], [[-bottomDiameter / 2, distanceApart], [-8, 0]]));
        setBandGradient(bandLeft, color);
        const bandMiddle = new Path(Segments([[0, 0]], [[0, distanceApart]]));
        setBandGradient(bandMiddle, color);
        bandMiddle.strokeCap = "square";
        const bandRight = new Path(Segments([[topDiameter / 2, 0], , [10, 0]], [[bottomDiameter / 2, distanceApart], [8, 0]]));
        setBandGradient(bandRight, color);
        // Assemble together.
        let graphic = new Group([topRing, bottomRing, bandLeft, bandRight, bandMiddle]);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape()
        };
    }
}
PlasticJointClip.properties = {
    label: "Plastic Joint Clip",
    defaultAppearance: {
        diameter: 30,
        color: "red"
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "diameter", label: "Diameter",
            min: 20, max: 50
        },
        {
            spec: "color-wells", key: "color", label: "Colour",
            colors: [
                { value: "red", label: "Red" },
                { value: "green", label: "Green", tier: "boost" },
                { value: "blue", label: "Blue", tier: "boost" },
                { value: "yellow", label: "Yellow", tier: "boost" },
                { value: "white", label: "White", tier: "boost" },
            ],
        }
    ],
};
function baseColor(input) {
    switch (input) {
        case "red": return "#de5a4e";
        case "green": return "#32a852";
        case "blue": return "#2266d4";
        case "yellow": return "#e0d836";
        case "white": return "#dddddd";
    }
}
function setRingGradient(item, color) {
    let darkerColor = color.color().darken(0.15).hex();
    let outlineColor = color.color().darken(0.4).hex();
    item.setGradientFill("right", [[darkerColor, 0.0], [color, 0.5], [darkerColor, 1.0]]);
    item.withStroke("thinner", outlineColor);
}
function setBandGradient(item, color) {
    let darkColor = color.color().darken(0.2).hex();
    let darkerColor = color.color().darken(0.4).hex();
    item.setGradientStroke("down", [[darkColor, 0.0], [darkerColor, 1.0]]);
    item.strokeCap = "butt";
    item.strokeWidth = BAND_THICKNESS;
}
